export default "__VITE_ASSET__DTmoej4C__"